export const faq = {
  hero: {
    heading: {
      1: 'De',
      2: 'meest gestelde vragen',
      3: 'op een overzichtelijke pagina',
    },
    description: {
      1: 'Heb je een vraag? Grote kans dat je het antwoord hieronder al vindt. We hebben de meest gestelde vragen voor je op een rij gezet, zodat je snel en eenvoudig zelf verder kunt.',
      2: 'Kom je er toch niet uit? Dan staat onze klantenservice natuurlijk voor je klaar.'
    }
  },
  questions: {
    1: {
      question: 'Wat is Bistroo en hoe werkt het?',
      answer: 'Bistroo is een innovatief softwarebedrijf dat zich richt op de digitalisering van de horeca. Het bedrijf biedt gebruiksvriendelijke tools aan waarmee restaurants, cafés en andere horecazaken hun online aanwezigheid kunnen verbeteren en zelfstandig kunnen beheren.',
      bullet_title: 'Bistroo levert onder andere:',
      bullets: {
        1: 'Websites en webshops voor horecazaken, volledig aanpasbaar naar jouw wensen.',
        2: 'QR-modules waarmee klanten gemakkelijk via hun mobiel op locatie kunnen bestellen en betalen.',
        3: 'Een beheersysteem waarin je alles zelf kunt instellen: menu’s, openingstijden, acties, bezorg instellingen, en meer.'
      },
      how: 'Hoe werkt het?',
      list: {
        1: 'Je maakt een account aan bij Bistroo en richt jouw digitale omgeving in. Je kunt je menukaart toevoegen, instellingen wijzigen, de betaalmethode koppelen en zelf bepalen hoe jouw online restaurant eruitziet.',
        2: 'Zodra alles klaar staat, gaat jouw website, webshop of QR-module live. Klanten kunnen je vinden, bestellingen plaatsen of ter plekke via QR bestellen.',
        3: 'Jij houdt volledige controle over je winkel. Alles is zelf instelbaar, maar als je hulp nodig hebt, staat het supportteam van Bistroo voor je klaar om je optimaal te ondersteunen.'
      }
    },
    2: {
      question: 'Is Bistroo gratis?',
      answer: 'Ja, Bistroo biedt een gratis instappakket aan. Dit betekent dat je als horecaondernemer kosteloos gebruik kunt maken van de modules, zonder maandelijkse abonnementskosten of opstartkosten.',
      how: 'Hoe werkt het gratis pakket?',
      bullets: {
        1: 'Gratis opstarten: Je kunt meteen beginnen met het opzetten van je webshop en website, geen opstartkosten! Alleen bij de QR module rekenen wij de kostprijs van de stickers door.',
        2: 'Geen abonnementskosten: wij rekenen geen vaste abonnementskosten, wij vragen alleen een commissiepercentage bij een geslaagde bestelling.',
        3: 'Zelf in te richten: Je hebt toegang tot alle basisfuncties om jouw digitale omgeving volledig naar wens in te richten.',
        4: 'Support beschikbaar: Ook als gratis gebruiker kun je rekenen op ondersteuning van ons supportteam.',
        5: 'Makkelijk switchen: je kan elke maand switchen naar een ander pakket.'
      },
      why: 'Waarom dit model?',
      why_answer: 'Bistroo wil horecaondernemers de vrijheid geven om zonder financiële drempels te starten met digitaliseren. Pas als je daadwerkelijk resultaat behaalt, betaal je een percentage aan commissie. Dit maakt het een laagdrempelige en eerlijke oplossing voor zowel startende als gevestigde horecazaken.'
    },
    3: {
      question: 'Kan ik Bistroo eerst uitproberen?',
      answer: 'Ja, zeker! Alle pakketten van Bistroo zijn 30 dagen gratis uit te proberen. Dit betekent dat je zonder verplichtingen gebruik kunt maken van alle functionaliteiten van het pakket dat bij jouw horecazaak past, of je nu kiest voor een website, webshop of QR-bestelmodule.',
      what: 'Wat houdt de proefperiode in?',
      bullets: {
        1: '30 dagen gratis toegang tot alle functies van het gekozen pakket.',
        2: 'Volledige vrijheid om jouw digitale omgeving in te richten en te testen.',
        3: 'Ondersteuning van het supportteam tijdens de volledige proefperiode.',
        4: 'Hardware in bruikleen (mits van toepassing) gedurende de proefperiode.'
      }
    },
    4: {
      question: 'Hoe gaan jullie om met extra verzoeken?',
      answer: {
        1: 'Bij Bistroo nemen we extra verzoeken serieus. Ons supportteam verwerkt dagelijks alle binnenkomende verzoeken, zodat je snel geholpen wordt en jouw online omgeving altijd up-to-date blijft.',
        2: 'Daarnaast houden we wekelijks een overleg waarin we alle binnengekomen feedback en verzoeken bespreken. Tijdens dit overleg beoordelen we welke suggesties kunnen worden meegenomen in toekomstige feature-updates.'
      }
    },
    5: {
      question: 'Hoe werken uitbetalingen bij Bistroo?',
      answer: {
        1: 'Bij Bistroo zijn uitbetalingen eenvoudig, flexibel en volledig geautomatiseerd.',
        2: 'Kortom: Jij houdt de controle over je geldstromen, en wij zorgen voor een soepel en overzichtelijk proces. Net zo makkelijk.'
      },
      bullets: {
        1: 'Koppel je betaalprovider aan ons systeem.',
        2: 'Bepaal zelf het uitbetalingsmoment: je kiest of je dagelijks, wekelijks of maandelijks uitbetaald wilt worden precies zoals het bij jouw onderneming past.',
        3: 'Automatische facturatie: Voor elke uitbetaling wordt automatisch een factuur gegenereerd, zodat je administratie altijd klopt en up-to-date is.'
      }
    },
    6: {
      question: 'Waarom zou ik voor jullie kiezen? Wat maakt jullie anders?',
      answer: {
        1: 'Met Bistroo ben jij weer volledig de ondernemer. Onze oplossing geeft jou als verkoper de regie over jouw online winkel. Je wordt écht proceseigenaar, met volledige controle over je online restaurant. Wij bieden alle tools en ondersteuning die je nodig hebt om jouw restaurant online succesvol te maken.',
        2: 'In de Manager, ons gebruiksvriendelijke backoffice dashboard beheer je eenvoudig alles in realtime: van menu’s, prijzen, kortingen en promoties tot (terug) betalingen en klantgegevens. Alles overzichtelijk en intuïtief, zodat jij je kunt focussen op wat echt telt.',
        3: 'Bistroo biedt daarnaast een unieke prijsstelling: jij kiest het kostenplaatje dat bij jouw onderneming past. Geen verrassingen, geen kleine lettertjes.',
        4: 'Bistroo geeft jou de vrijheid om online te ondernemen op jouw manier.'
      },
      bullets: {
        1: '30 dagen gratis uitproberen',
        2: 'Maandelijks opzegbaar',
        3: 'Geen stiekeme contracten, gewoon duidelijk en transparant'
      }
    },
    7: {
      question: 'Hoe werkt het administratief?',
      answer: {
        1: 'Bij Bistroo is de administratie zo eenvoudig mogelijk ingericht. Voor elke uitbetaling ontvang je automatisch een duidelijke omzet factuur met alle benodigde details. Zo kun je deze direct inboeken zonder gedoe.',
        2: 'Kortom: je administratie is altijd compleet, overzichtelijk en klaar voor je boekhouding zonder extra handmatige handelingen.'
      }
    },
    8: {
      question: 'Hoelang duurt het onboarden?',
      answer: 'Bij Bistroo sta je snel online: binnen 48 uur is jouw online restaurant volledig ingericht en klaar voor gebruik. Zo kun je vrijwel direct starten met bestellen en verkopen!'
    },
    9: {
      question: 'Welke betaalmethoden ondersteunen jullie?',
      answer: 'Bistroo werkt samen met toonaangevende betaalproviders Stripe en Mollie. Via deze partijen ondersteunen we vrijwel alle gangbare (en minder gangbare) betaalmethoden, zowel in Nederland als België. Denk aan, IDEAL, Bancontact, Apple Pay, Google Pay, Creditcard en nog veel meer betaalmethoden. Jij hebt zelf volledige controle over de betaalmethoden die jij wilt aanbieden, zet deze simpelweg aan of uit via het portaal van de betaalprovider.'
    },
    10: {
      question: 'Hoe krijgen wij de bestellingen binnen in het restaurant?',
      answer: {
        1: 'Bij Bistroo heb je meerdere flexibele opties om bestellingen binnen te krijgen, afgestemd op wat het beste bij jouw restaurant past. Bestellingen komen standaard direct binnen in je e-mailbox. Notificaties verschijnen ook direct in onze Manager app of in het manager portaal en je kan SMS notificaties aanzetten. ',
        2: 'Wil je het helemaal makkelijk maken? Wij leveren ook hardware zoals bonnenprinters en handhelds. Bovendien kunnen we in veel gevallen jouw bestaande printers in het restaurant koppelen, zodat je meteen aan de slag kunt zonder extra apparatuur.',
        3: 'Daarnaast bieden wij vaak ook koppelingen met kassasystemen, zodat bestellingen naadloos in jouw huidige workflow worden geïntegreerd. Zo bespaar je tijd en minimaliseer je fouten bij de verwerking.',
        4: 'Kortom: met Bistroo kies je zelf hoe je jouw bestellingen ontvangt, helemaal op maat van jouw bedrijfsvoering.'
      }
    },
    11: {
      question: 'Hoe kan ik starten? Wat is daar voor nodig?',
      answer: 'Je kunt direct starten, daar is helemaal niks voor nodig. Wil je aan de slag? Maak gewoon gratis een account aan op onze website, dat kan meteen. Mocht je behoefte hebben aan specifieke hardware, dan kun je die eventueel bij ons kopen, maar het is absoluut geen vereiste.'
    },
    12: {
      question: 'Vragen jullie opstartkosten?',
      answer: 'Bij ons betaal je géén opstartkosten. Uitsluitend voor de QR-module rekenen we de kostprijs van de QR-stickers door. '
    }
  }
}